import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import {AnimatePresence} from 'framer-motion';
import {Icon, symbolUrl} from '../common';

export default function Button({
    theme = 'primary',
    classes = '',
    iconClassName = 'icon icon--24',
    textClassName = 'btn__text',
    linkHref,
    linkTitle,
    linkTarget,
    linkRel = '',
    onClick,
    type = 'button',
    isLoading,
    ...rest
}) {
    if (linkHref) {
        return (
            <a
                className={`btn btn-${theme} ${classes}`}
                href={linkHref}
                title={linkTitle}
                target={linkTarget}
                rel={linkRel}
                onClick={onClick}>
                <span className={textClassName}>{linkTitle}</span>
                <Icon url={symbolUrl('arrow')} size="24" classes={iconClassName} />
            </a>
        );
    } else {
        return (
            <button
                className={`btn btn-${theme} ${classes}`}
                type={type}
                onClick={onClick}
                disabled={isLoading} {...rest}>
                <span className={textClassName}>{linkTitle}</span>
                <div className="btn__icon-wrapper d-flex align-self-center">
                    <AnimatePresence initial={false}>
                        {isLoading && (
                            <div
                                className="loading-progress-wrapper d-flex align-self-center">
                                <div className="loading__element">
                                    <CircularProgress
                                        classes={{
                                            root:
                                                'loading loading--circular-progress loading--circular-progress-xl loading--circular-progress-white',
                                        }}
                                    />
                                </div>
                            </div>
                        )}
                        {!isLoading && (
                            <div
                                className="d-flex align-self-center">
                                <Icon url={symbolUrl('arrow')} size="24" classes={iconClassName} />
                            </div>
                        )}
                    </AnimatePresence>
                </div>
            </button>
        );
    }
}
